module.exports = __webpack_public_path__ + "img/shield-open.5edb4f7a.svg";